<template>
  <div>
    <div class="menu-back-wrap">
      <div class="menu-back"></div>
    </div>
    <topnav></topnav>

    <div class="faq-page-wrap" v-if="isAuthenticated">
      <div class="contest-page-wrap">
        <div class="contest-page-img">
          <h3 class="txt60 red">Let's Mix!</h3>
          <img src="../assets/mixdragon.png" class="mixdragon" />
        </div>

        <div class="">
          <h2 class="txt30 blue-txt">Creature Feature #1</h2>
          <p class="txt20 light">
            Want your name immortalized in the game? Suggest a new parent and
            you might win these amazing prizes:
          </p>

          <div>
            <p class="txt18">
              <strong>3rd place:</strong> name 1 mixed creature, created from
              your suggested parent.
            </p>
            <p class="txt18">
              <strong>2nd place:</strong> also help us write the index entry for
              your mixed creature.
            </p>
            <p class="txt18">
              <strong>1st place:</strong> also get an achievement, named in your
              honor.
            </p>
          </div>

          <p class="txt18">
            To participate you must be over 13 years old and submit your
            suggestion before 13th of november, PT.
          </p>
        </div>
      </div>

      <div class="faq-page-box sup">
        <p class="txt20">
          Enter the Creature Feature #1 competition by filling the form below:
        </p>

        <div class=" ">
          <form
            @submit.prevent="sendForm"
            v-if="formStatus != 'success'"
            class="form form-grid"
          >
            <div>
              <div class="relative">
                <img src="../assets/iconusr.svg" class="form-icon" />
                <input
                  id="name"
                  placeholder="Name"
                  v-model="form.name"
                  type="text"
                  class="txt-field full"
                  required
                />
              </div>

              <div class="relative">
                <img src="../assets/Star.svg" class="form-icon" />
                <input
                  id="suggestion"
                  placeholder="Your suggestion"
                  v-model="form.suggestion"
                  type="text"
                  class="txt-field full"
                  required
                  style="margin-bottom: 20px"
                />
              </div>
              <div class="relative">
                <img src="../assets/iconmeg.svg" class="form-icon msg" />
                <textarea
                  id="reason"
                  placeholder="Why do you think this would be a cool addition to the game?"
                  v-model="form.reason"
                  class="txt-field bigger full"
                ></textarea>
              </div>
            </div>

            <div>
              <div class="relative">
                <img
                  src="../assets/iconemail.svg"
                  class="form-icon"
                  style="top: 5px"
                />
                <input
                  id="email"
                  placeholder="Email"
                  v-model="form.email"
                  type="email"
                  class="txt-field full"
                  required
                />
              </div>
              <div class="txt18 px-1" style="margin-top: 3rem;">
                <label>
                  <input
                    type="checkbox"
                    v-model="form.agreedToTerms"
                    required
                  />
                  I read and agreed to the
                  <a href="/creature-competition" class="contest-small-link"
                    >Contest Terms</a
                  >
                </label>
              </div>

              <p class="txt18 px-1"  style="margin-bottom: 3rem;">
                If you have any questions, feel free to contact our
                <a href="/support" class="contest-small-link">Support</a>
              </p>

              <div class="form-btn-wrap">
                <input
                  class="btn sup"
                  type="submit"
                  value="Submit"
                  :disabled="!form.agreedToTerms"
                  :style="{
                    opacity: form.agreedToTerms ? 1 : 0.5,
                    cursor: form.agreedToTerms ? 'pointer' : 'not-allowed',
                  }"
                />
              </div>
            </div>
          </form>

          <div class="tnx" v-if="formStatus == 'success'">
            <p class="">
              <span class="new-line">Thank you!</span> Your submission has been
              received!
            </p>
          </div>

          <div class="error" v-if="formStatus == 'fail'">
            <p>
              An error occurred while submitting the form. Please try again.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="faq-page-wrap" style="text-align: center; padding: 100px 20px;">
      <h2 class="txt40">Access Restricted</h2>
      <p class="txt20">Please enter the correct password to access this page.</p>
    </div>

    <botfooter></botfooter>
  </div>
</template>

<script>
import Botfooter from "@/components/Botfooter.vue";

import Topnav from "@/components/Topnav.vue";
export default {
  components: {
    Topnav,
    Botfooter,
  },
  data: () => ({
    formStatus: "",
    isAuthenticated: false,
    form: {
      name: "",
      email: "",
      suggestion: "",
      reason: "",
      agreedToTerms: false,
    },
  }),
  methods: {
    checkPassword() {
      const password = prompt("Enter password to access this page:");
      if (password === "mixdragon") {
        this.isAuthenticated = true;
      } else if (password !== null) {
        alert("Incorrect password. Access denied.");
        this.$router.push('/');
      } else {
        // User cancelled the prompt
        this.$router.push('/');
      }
    },
    async sendForm() {
      if (!this.form.agreedToTerms) {
        alert("Please agree to the contest terms before submitting.");
        return;
      }

      try {
        await this.$db.collection("creatureCompetition").post({
          ...this.form,
          submittedAt: new Date().toISOString(),
          competition: "creature-feature-1",
        });
        this.formStatus = "success";
      } catch (err) {
        console.log(
          err.response && err.response.data ? err.response.data : err
        );
        this.formStatus = "fail";
      }
    },
  },
  mounted() {
    this.checkPassword();
  },
  name: "CreatureCompetition",
};
</script>
<style scoped>
.faq-page-box {
  min-height: 0;
}

.faq-page-box.sup {
  padding: 50px;
}
.contest-page-wrap {
  display: flex;
  gap: 1rem;
  overflow-x: hidden;
}
.contest-page-img {
  min-width: 400px;
}
.contest-page-img img {
  width: 350px;
  margin-top: -2rem;
}


@media screen and (max-width: 767px) {
  .faq-page-box.sup {
    padding: 20px;
  }
  .contest-page-wrap {
    display: block;
    gap: 1rem;
  }
  .contest-page-img {
    min-width: 0;
    text-align: center;
  }
}
</style>
